import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { Http } from "../../utils/http";
import { Xhshow } from "../../utils/xhsXsEncrypt";

// 小红书参数加密器
const xsEncrypt = new Xhshow();

export interface HotTopicResponse {
    code: number;
    success: boolean;
    msg: string;
    data: {
        activity_list: HotTopicDetail[];
    };
}

export interface HotTopicDetail {
    page_id: string;
    activity_name: string;
    start_time: number;
    activity_status: number;
    capa_deep_link: string;
    instance_id: number;
    activity_id: number;
    end_time: number;
    picture_link: string;
    focus_status: number;
    activity_reward: string;
    activity_link: string;
    sort_score: string;
    pc_post_link: string;
    topic_infos: [
        {
            id: string;
            name: string;
            link: string;
        },
    ];
}

export type PublishAction = CommonAction<ActiomCommonParams, HotTopicDetail[]>;

export const getXhsHotTopic: PublishAction = async (_task, params) => {
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://creator.xiaohongshu.com",
        origin: "https://creator.xiaohongshu.com",
    };
    const args: AxiosProxyParams = [
        { headers },
        _task.logger,
        params.proxyLoc,
        params.localIP,
        // params.huiwenToken,
        params.accountId,
    ];
    const http = new Http(...args);

    const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    if (!a1Cookie) return { code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: [] };

    const hotTopicParams = {
        sort: 1,
        type: 1,
        source: 3,
        topic_activity: 1,
    };
    const fatchTopic = "/api/galaxy/v2/creator/activity_center/list";
    const recordCookie = params.cookies.reduce<Record<string, string>>((acc, cookie) => {
        if (cookie.name && cookie.value) {
            acc[cookie.name] = cookie.value;
        }
        return acc;
    }, {});
    const searchXsHeader = xsEncrypt.signHeadersGet(fatchTopic, recordCookie, "xhs-pc-web", hotTopicParams);

    const res = await http.api<HotTopicResponse>(
        {
            method: "get",
            url: "https://creator.xiaohongshu.com/api/galaxy/v2/creator/activity_center/list",
            params: hotTopicParams,
            headers: searchXsHeader,
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    const isSuccess = res.code === 0;
    const message = `热门信息获取${isSuccess ? "成功" : `失败，原因：${res.msg}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;
    const data = isSuccess ? res.data.activity_list : [];

    return response(isSuccess ? 0 : 414, message, data);
};
